var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16ZM9.6 5.6C9.6 5.824 9.432 6.24 9.264 6.4L8 7.664C7.544 8.128 7.2 8.944 7.2 9.6V10.4H8.8V9.6C8.8 9.368 8.968 8.96 9.136 8.8L10.4 7.536C10.856 7.072 11.2 6.256 11.2 5.6C11.2 4.75131 10.8629 3.93737 10.2627 3.33726C9.66263 2.73714 8.84869 2.4 8 2.4C7.15131 2.4 6.33737 2.73714 5.73726 3.33726C5.13714 3.93737 4.8 4.75131 4.8 5.6H6.4C6.4 5.17565 6.56857 4.76869 6.86863 4.46863C7.16869 4.16857 7.57565 4 8 4C8.42435 4 8.83131 4.16857 9.13137 4.46863C9.43143 4.76869 9.6 5.17565 9.6 5.6ZM7.2 12V13.6H8.8V12H7.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/Guides.e8525816c0b2dcb3c26ce52ec207f806.svg";
export { ForwardRef as ReactComponent };